module.exports = __webpack_public_path__ + "static/media/seth.d93c1cc4.svg";